import React, {Fragment} from 'react'
import './index.less'
import Cooperate from '../../../layout/image/cooperate.png';
import Updata from '../../../layout/image/updata.png';
import Serve from '../../../layout/image/serve.png';

export const pageOne: React.FC = () => {

    return (
        <Fragment>
            <div className="update-wrapper">
                <div className="title-box">
                    <div className="content">
                        <div className="content__container  updata-title">
                            <p className="content__container__text ">
                                地勤
                            </p>
                            <ul className="content__container__list">
                                <li className="content__container__list__item">2.0版本</li>
                                <li className="content__container__list__item">全新发布!</li>
                                <li className="content__container__list__item">强势来袭!</li>
                            </ul>
                        </div>
                    </div>

                    <h2 className="advantage-title">「轻便」「简洁」「高效」「智能」</h2>
                </div>

                <div className="model-box">
                    <div className="model">
                        <img className="model-img" src={Cooperate} alt=""/>
                        <div className="model-title-box">
                            <h1 className="model-title main-title">地勤工作全流程</h1>
                            <h3 className="model-title small-title">清晰感知一线同事的一天</h3>
                        </div>

                    </div>
                    <div className="model">
                        <img className="model-img" src={Updata} alt=""/>
                        <div className="model-title-box">
                            <h1 className="model-title main-title">页面样式交互全新升级</h1>
                            <h3 className="model-title small-title">独立定制、操作习惯、日常工作统统提效</h3>
                        </div>
                    </div>

                    <div className="model">
                        <img className="model-img" src={Serve} alt=""/>
                        <div className="model-title-box">
                            <h1 className="model-title main-title">底层能力全面升级</h1>
                            <h3 className="model-title small-title">开发工具、模拟菜单、数据下发陆续建设中</h3>
                        </div>
                    </div>

                </div>
            </div>
        </Fragment>
    )
}

export default pageOne;
